"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { useForm } from "react-hook-form";
import zod from "zod";

import { Button } from "@/components/ui/button";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";

const DesoBountyAnalyzerFormSchema = zod.object({
  username: zod
    .string({
      error: "Username must be a string",
    })
    .min(1, {
      message: "Username must contain at least 1 character(s)",
    })
    .max(25, {
      message: "Username length must be less than 25",
    })
    .refine((v) => {
      const regexp = /^[a-zA-Z0-9_]*$/g;
      return regexp.test(v);
    }, "Must only include alpha numeric or '_'"),
});

export const BountyAnalyzerForm = () => {
  const router = useRouter();
  const [submitting, setSubmitting] = useState(false);

  const desoBountyAnalyzerForm = useForm<
    zod.infer<typeof DesoBountyAnalyzerFormSchema>
  >({
    resolver: zodResolver(DesoBountyAnalyzerFormSchema),
    defaultValues: {
      username: "nadertheory",
    },
    mode: "onChange",
  });

  const onDesoBountyAnalyzerFormSubmit = async (
    values: zod.infer<typeof DesoBountyAnalyzerFormSchema>,
  ) => {
    setSubmitting(true);
    // Do some logic probably in internal route
    router.push(`/bounty/${values.username}`);
  };

  return (
    <Form {...desoBountyAnalyzerForm}>
      <form
        onSubmit={desoBountyAnalyzerForm.handleSubmit(
          onDesoBountyAnalyzerFormSubmit,
        )}
        className="w-full rounded-2xl text-left"
      >
        <div className="mb-4 space-y-2">
          <FormField
            control={desoBountyAnalyzerForm.control}
            name="username"
            render={({ field }) => (
              <FormItem className="flex w-full flex-wrap items-center">
                <FormLabel htmlFor="deso-username">Username</FormLabel>

                <FormControl>
                  <Input
                    id="deso-username"
                    className="placeholder:text-muted"
                    placeholder="Enter a username"
                    {...field}
                  />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <section className="mt-4 text-center">
          <div className="flex flex-col items-center gap-4 text-xs">
            <p>Evaluate bounty to see what the profile is worth.</p>
            <Button type="submit" disabled={submitting}>
              {submitting ? "Evaluating..." : "Evaluate Bounty"}
            </Button>
          </div>
        </section>
      </form>
    </Form>
  );
};
